import React, { useContext, useEffect } from "react";
import HeaderLayout from "./HeaderLayout";
import { UserContext } from "./Context/UserContext";
import SubmenuHeader from "./SubmenuHeader";
import { useNavigate } from "react-router-dom";

export default function HeaderLayoutWrapper() {
  const { selectedMenu, setSelectedMenu } = useContext(UserContext);

  const navigate = useNavigate();
  // DIRECT PO SHORT KEY (shift+d)
  const handleKeyPress = (event) => {
    if (event.shiftKey && event.keyCode === 68) {
      event.preventDefault();
      // setIsSearchOpen((prevVisible) => !prevVisible);
      navigate("/purchase/direct-po-create");
      setSelectedMenu(null);
    }else if(event.shiftKey && event.keyCode ===73){
      event.preventDefault();
      navigate("/purchase/create-indent")
    }else if(event.shiftKey && event.keyCode ===71){
      event.preventDefault();
      navigate("/purchase/generate-enquiry")
    }else if(event.shiftKey && event.keyCode ===69){
      event.preventDefault();
      navigate("/purchase/view-enquiry")
    }else if(event.shiftKey && event.keyCode ===81){
      event.preventDefault();
      navigate("/purchase/view-quotation")
    }else if(event.shiftKey && event.keyCode ===67){
      event.preventDefault();
      navigate("/purchase/compare-quotation")
    }
    // console.log("keyCode", event.keyCode);
  };
  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <React.Fragment>
      <HeaderLayout />
      <SubmenuHeader selectedMenu={selectedMenu} />
    </React.Fragment>
  );
}
